import React, { useEffect, useRef, useState } from 'react'
import Range from '../../components/Range'
import useRange from '../../hooks/range.hook'
import useAdminApi from '../../API/admin.api'
import styles from '../../styles/pages/statistic.module.css'
import useChart from '../../hooks/chart.hook'
import { getDate } from '../../utils/time.utils'


function Statistics() {
    const adminApi = useAdminApi()

    const range = useRange(getDate(new Date(Date.now())))

    const [type, setType] = useState('Day') 
    const [triger, setTriger] = useState(false)
    const [statistic, setStatistic] = useState(null)
    const [statisticP2P, setStatisticP2P] = useState(null)

    const canvasTotal = useRef()
    const canvasConvercion = useRef()
    const canvasProfit = useRef()

    const canvasAcqTotal = useRef()
    const canvasAcqConvercion = useRef()
    const canvasAcqProfit = useRef()

    const totalChart = useChart(canvasTotal, 'bar')
    const ConvercionChart = useChart(canvasConvercion, 'line', {scales: { y: { min: 0, max: 1 }}})
    const ProfitChart = useChart(canvasProfit, 'bar')

    const totalAcqChart = useChart(canvasAcqTotal, 'bar')
    const ConvercionAcqChart = useChart(canvasAcqConvercion, 'line', {scales: { y: { min: 0, max: 1 }}})
    const ProfitAcqChart = useChart(canvasAcqProfit, 'bar')

    const setTypeHandler = (type) => {
        setType(type)

        let startDate = ''

        if(type === 'Day') { startDate = getDate(new Date(Date.now())) }
        if(type === 'Weak') { startDate = getDate(new Date(Date.now() - 1000 * 60 * 60 * 24 * 6)) }
        if(type === 'Month') { startDate = getDate(new Date(Date.now() - 1000 * 60 * 60 * 24 * 30)) }
        
        range.setValue(startDate)

        setTriger((prew) => !prew)
    }

    const loadStatistic = async (costumLoad=true) => { 
        if(costumLoad) { setType('Custom') }

        const { start, stop } = range.value 
        const res = await adminApi.statistic(start, stop)
        setStatistic(res)

        const getLabel = (item) => {
            if(type === 'Day') { return `${item._id.slice(-2)}:00` }
            return `${item._id.slice(-2)}`
        }

        totalChart.setData(res.invoices.data.map(getLabel), [ { label: "Total amount", data: res.invoices.data.map((item) => item.totalConfirm) }])
        ConvercionChart.setData(res.invoices.data.map(getLabel), [ { label: "Conversion", data: res.invoices.data.map((item) => item.conversion) }])
        ProfitChart.setData(res.invoices.data.map(getLabel), [ { label: "Profit", data: res.invoices.data.map((item) => item.profit) }])

        // totalAcqChart.setData(res.acq.data.map(getLabel), [ { label: "Total amount Acq", data: res.acq.data.map((item) => item.totalConfirm) }])
        // ConvercionAcqChart.setData(res.acq.data.map(getLabel), [ { label: "Conversion Acq", data: res.acq.data.map((item) => item.conversion) }])
        // ProfitAcqChart.setData(res.acq.data.map(getLabel), [ { label: "Profit Acq", data: res.acq.data.map((item) => item.profit) }])
   
        const resP2P = await adminApi.workerStatistic('67b213a29c47221ce085a3b2', start, stop)
        setStatisticP2P(resP2P)        

        totalAcqChart.setData(resP2P.invoices.data.map(getLabel), [ { label: "Total amount", data: resP2P.invoices.data.map((item) => item.totalConfirm) }])
        ConvercionAcqChart.setData(resP2P.invoices.data.map(getLabel), [ { label: "Conversion", data: resP2P.invoices.data.map((item) => item.conversion) }])
        ProfitAcqChart.setData(resP2P.invoices.data.map(getLabel), [ { label: "Profit", data: resP2P.invoices.data.map((item) => item.profit) }])
    } 

    useEffect(() => { loadStatistic(false).then() }, [triger])

    return (
        <div className='w-100'>
            <h2>Statistics</h2>
            <br />
            <div className='d-flex'>
                <Range range={range.bind} />
                <button className='button' onClick={() => loadStatistic()}>Load</button>
            </div>

            <div className={styles.switch}>
                <div className={`${styles.button} ${type === 'Month'? styles.active : null}`} onClick={() => setTypeHandler('Month')}>Month</div>
                <div className={`${styles.button} ${type === 'Weak'? styles.active : null}`} onClick={() => setTypeHandler('Weak')}>Weak</div>
                <div className={`${styles.button} ${type === 'Day'? styles.active : null}`} onClick={() => setTypeHandler('Day')}>Day</div>
            </div>

            <div className={styles.main}>
                <div className={styles.info}>
                    <div>
                        <h3>Invoices</h3>
                        <div><b>count:</b> {statistic?.invoices?.count}</div>
                        <div><b>conversion:</b> {parseInt(statistic?.invoices?.conversion * 100)}%</div>
                        <div><b>Avarage Time:</b> {parseInt(statistic?.invoices?.avarageTime / (1000 * 60))} min {parseInt(statistic?.invoices?.avarageTime / 1000) % 60} s</div>
                        <div><b>Avarage Summ:</b> {parseInt(statistic?.invoices?.avarageSum)} uah</div>
                        <div><b>Total Summ:</b> {parseInt(statistic?.invoices?.total.toFixed(2))} uah</div>
                        <div><b>Commision:</b> {statistic?.invoices?.profit.toFixed(2)} uah</div>
                        <div><b>change:</b> {statistic?.invoices?.changeCount}</div>
                        {statistic?.invoices?.workers &&
                            Object.entries(statistic.invoices.workers).map(([key, value]) => (
                                value? <div key={key}><b>{key}:</b> {value}</div> : null
                            ))
                        }
                        <div><b>NCPAY: Not Find:</b> {statistic?.errors?.NCPAY?.notFind}</div>
                        <div><b>NCPAY: Bad Conv:</b> {statistic?.errors?.NCPAY?.badConv}</div>
                        <div><b>NCP2P: Not Find:</b> {statistic?.errors?.NCP2P?.notFind}</div>
                        <div><b>NCP2P: Bad Conv:</b> {statistic?.errors?.NCP2P?.badConv}</div>
                        <div><b>NCP2P: Double:</b> {statistic?.errors?.NCP2P?.double}</div>
                        <div><b>NCP2P: Scam:</b> {statistic?.errors?.NCP2P?.scam}</div>
                    </div>
                    <div>
                        <h3>P2P Invoices</h3>
                        <div><b>count:</b> {statisticP2P?.invoices?.count}</div>
                        <div><b>conversion:</b> {parseInt(statisticP2P?.invoices?.conversion * 100)}%</div>
                        <div><b>Avarage Time:</b> {parseInt(statisticP2P?.invoices?.avarageTime / (1000 * 60))} min {parseInt(statisticP2P?.invoices?.avarageTime / 1000) % 60} s</div>
                        <div><b>Avarage Summ:</b> {parseInt(statisticP2P?.invoices?.avarageSum)} uah</div>
                        <div><b>Total Summ:</b> {parseInt(statisticP2P?.invoices?.total.toFixed(2))} uah</div>
                        <div><b>Commision:</b> {statisticP2P?.invoices?.profit.toFixed(2)} uah</div>
                        <div><b>change:</b> {statisticP2P?.invoices?.changeCount}</div>
                    </div>
                    <div>
                        <h3>Payments</h3>
                        <div><b>count:</b> {statistic?.payments?.count}</div>
                        <div><b>Commision:</b> {statistic?.payments?.profitCommision?.toFixed(2)}</div>
                        <div><b>conversion:</b> {parseInt((statistic?.payments?.confirm / statistic?.payments?.count) * 100)}%</div>
                        <div><b>Avarage Time:</b> {parseInt(statistic?.payments?.time / (1000 * 60))} min {parseInt(statistic?.payments?.time / 1000) % 60} s</div>
                        <div><b>Avarage Summ:</b> {parseInt(statistic?.payments?.summ)} uah</div>
                        <div><b>Total Summ:</b> {parseInt(statistic?.payments?.profitSum)} uah</div>
                    </div>
                    <div>
                        <h3>Finance</h3>
                        <div><b>All transit balance UAH:</b> {statistic?.transactionBalance?.toFixed(2)}</div>
                        <div><b>All transit balance USDT:</b> {statistic?.transactionBalanceUstd?.toFixed(2)} uah</div>
                        <div><b>Avg transit rate:</b> {(statistic?.transactionBalance / statistic?.transactionBalanceUstd)?.toFixed(2)} uah</div>
                    
                        <div><b>ncApi UAH:</b> {statistic?.ncApiTotal?.toFixed(2)} uah</div>
                        <div><b>ncApi USDT:</b> {statistic?.ncApiTotalUsdt?.toFixed(2)} usdt</div>
                        <div><b>ncApi Avg rate:</b> {statistic?.ncApyAvgRate?.toFixed(2)}</div>
                    
                        <div><b>ncAPI debit:</b> {statistic?.ncAPIdebt?.toFixed(2)} usdt</div>
                    </div>
                </div>
                <div className={styles.flex}>
                    <div className={styles.view}>
                        <canvas id="total" ref={canvasAcqTotal}></canvas>
                        <canvas id="conversion" ref={canvasAcqConvercion}></canvas>
                        <canvas id="profit" ref={canvasAcqProfit}></canvas>
                    </div>
                    <div className={styles.view}>
                        <canvas id="total-acq" ref={canvasTotal}></canvas>
                        <canvas id="conversion-acq" ref={canvasConvercion}></canvas>
                        <canvas id="profit-acq" ref={canvasProfit}></canvas>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Statistics